import { render, staticRenderFns } from "./OrangeDeepLink.vue?vue&type=template&id=010623e6&scoped=true&"
import script from "./OrangeDeepLink.vue?vue&type=script&lang=js&"
export * from "./OrangeDeepLink.vue?vue&type=script&lang=js&"
import style0 from "./OrangeDeepLink.vue?vue&type=style&index=0&id=010623e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010623e6",
  null
  
)

export default component.exports